// Component: WakeletEmbed
// Author: Rahul A
import * as React from 'react';
import WakeletEmbedNPM from '@rotaryintl/app-wakelet-embed';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const WakeletEmbed = (props) => {
  return (
    <>
      <WakeletEmbedNPM title={props.fields?.Title?.value} wakeletID={props.fields?.WakeletID?.value} />
    </>
  );
};

export default withSitecoreContext()(WakeletEmbed);
